// extracted by mini-css-extract-plugin
export default {"wrapper":"ThemeSwitch_wrapper__sS3V3","icon":"ThemeSwitch_icon__WTpv6","switch":"ThemeSwitch_switch__B3-iI","slider":"ThemeSwitch_slider__htRGR"};